export const SAVE_REGISTER_DATA = 'SAVE_REGISTER_DATA'
export const SAVE_REGISTER_DATA_SUCCESS = 'SAVE_REGISTER_DATA_SUCCESS'
export const SAVE_REGISTER_DATA_FAIL = 'SAVE_REGISTER_DATA_FAIL'

export const saveRegisterData = (params) => {
    return { type: SAVE_REGISTER_DATA, params }
}
 